module.exports = __webpack_public_path__ + "img/Lumberman-s-Monument.a24989ee.jpg";